import * as z from "zod";

export const paymentMethodStatusValue = z.enum([
  "active",
  "missing",
  "error",
  "requires_verification",
]);

export type PaymentMethodStatus = z.infer<typeof paymentMethodStatusValue>;

export const getPaymentMethodStatus = {
  name: "getPaymentMethodStatus" as const,
  input: z.object({}),
  output: z.object({
    paymentMethodStatus: z.object({
      primary: paymentMethodStatusValue,
      secondary: paymentMethodStatusValue,
    }),
  }),
};
